export { default } from './es/icons/MinusOutlined';